import Controller from '@ember/controller';
import { action, computed, get } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  store: service(),
  fundsService: service(),
  flashMessages: service(),
  router: service(),

  hasOtherFundPermissions: computed('model.userFundsRecords[]', function () {
    return get(this, 'model.userFundRecords.length') > 1;
  }),

  delete: task(function* () {
    yield this.fundsService.confirmValidFundToken();
    let userFundRecord = get(this, 'model.userFundRecord');
    let fundName = get(this, 'model.fund.name');
    let message = `The user no longer has permission to see the ${fundName} fund`;
    yield userFundRecord.destroyRecord();
    this.flashMessages.success(message);

    // TODO: Eric - do we need to refresh the route?
    this.router.transitionTo('admin.users.show');
  }).drop(),

  cancel: action(function () {
    window.history.back();
  }),
});
